Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useParagraphStyles = void 0;
var _FontSize = require("../FontSize");
var _useFont2 = require("./useFont");
var _useColors2 = require("./useColors");
var _useBreakpoints2 = require("./useBreakpoints");
var _reactNative = require("react-native-web");
var useParagraphStyles = exports.useParagraphStyles = function useParagraphStyles() {
  var _useColors = (0, _useColors2.useColors)(),
    colors = _useColors.colors;
  var _useBreakpoints = (0, _useBreakpoints2.useBreakpoints)(),
    bp = _useBreakpoints.bp;
  var _useFont = (0, _useFont2.useFont)(),
    fontRegular = _useFont.fontRegular;
  var paragraph = Object.assign({}, fontRegular, {
    fontSize: _FontSize.fontSize.normal,
    lineHeight: _FontSize.lineHeight.normal,
    color: colors.text,
    marginBottom: _reactNative.Platform.OS === 'web' ? "calc(".concat(_FontSize.fontSize.normal, " * 2)") : _FontSize.fontSize.normal * 2
  });
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    paragraph.fontSize = _FontSize.fontSize.s;
    paragraph.lineHeight = _FontSize.lineHeight.s;
    paragraph.marginBottom = _reactNative.Platform.OS === 'web' ? "calc(".concat(_FontSize.fontSize.s, " * 2)") : _FontSize.fontSize.s * 2;
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    paragraph.fontSize = _FontSize.fontSize.m;
    paragraph.lineHeight = _FontSize.lineHeight.m;
    paragraph.marginBottom = _reactNative.Platform.OS === 'web' ? "calc(".concat(_FontSize.fontSize.m, " * 2)") : _FontSize.fontSize.m * 2;
  }
  return {
    paragraph: paragraph
  };
};